import React from 'react';

import './style.scss';
const Feature = ({ img, title, desc }) => {
  return (
    <div className="feature">
      <div className="feature-header">
        <div
          className="feature-logo"
          style={{
            background: `url(${img}) no-repeat center`,
            backgroundSize: 'contain',
          }}
        ></div>
        <div className="feature-title">{title}</div>
      </div>
      <div className="feature-desc">{desc}</div>
    </div>
  );
};

export default Feature;
